import { 
    downloadBatchCreateBillExcel,
    uploadExcel,
    batchCreateBill,
    uploadPaidBillExcel,
    downloadBillAccountExcel
} from "@/apis/company/bill.js"; 
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_batch_list: 'bizBatchBill/set_batch_list',
    set_upload_list: 'bizBatchBill/set_upload_list',
    set_error_list: 'bizBatchBill/set_error_list',
    set_default: 'bizBatchBill/set_default',
}

// count state 必須是 Object
const state = {
    batchBillList: [],
    uploadList: [],
    errorList: [],
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_BATCH_BILL_LIST: (state) => {
        return state.batchBillList
    },
    GET_BIZ_BATCH_BILL_ERROR_LIST: (state) => {
        return state.errorList
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    bizDownloadBatchBillExcel ( {commit, dispatch} ) {
        return new Promise((resolve, reject) => {
            downloadBatchCreateBillExcel()
            .then(res => {
                console.log(res)
                if( res.status == 200 ){
                    if(res.data){
                        const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" }));
                        let a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = url;
                        a.download = 'batchUploadBillExcel';
                        a.click();
                        // window.open(url);
                    }
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                reject(err)
            })
        })
    },
    bizUploadBatchBill ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            if(!data.target.files.length) return
            commit(types.set_default);
            const files = data.target.files;
            console.log(files)
            let formData = new FormData();
                formData.append('file', files[0]);
            dispatch('setLoadingState', 1)
            uploadExcel(formData)
            .then(res => {
                console.log(res)
                dispatch('setLoadingState', 0)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_batch_list, res.data.result.billList);
                    commit(types.set_error_list, res.data.result.errorList);
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
                resolve()
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                dispatch('setLoadingState', 0)
                reject(err)
            })
        })
    },
    bizSaveBatchBill ( {commit, state, dispatch}) {
        return new Promise((resolve, reject) => {
            dispatch('setLoadingState', 1)
            batchCreateBill(state.uploadList)
            .then(res => {
                console.log(res)
                dispatch('setLoadingState', 0)
                if( res.status === 200 ){
                    dispatch('setAlarmStatus', {status: true,title: `成功上傳 ${res.data.createNum} 筆帳單`, description: '<a href="/enterprise/financialReport/billMgt">帳單紀錄 <img src="../../../static/img/black-arrow-down.svg" /></a>',type: 'success'})
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
                resolve()
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                dispatch('setLoadingState', 0)
                reject(err)
            })
        })
    },
    uploadPaidBill ( {commit, state, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            const files = data.target.files;

            let formData = new FormData();
                formData.append('file', files[0]);
            commit(types.set_file_state, 'loading')
            dispatch('setLoadingState', 1)
            uploadPaidBillExcel(formData)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    dispatch('setLoadingState', 0)
                    if( res.data.result.length > 0){
                        commit(types.set_batch_list, res.data.result);
                        commit(types.set_file_state, 'done')
                        resolve()
                    }else{
                        commit(types.set_fail, {status: true, msg: '上傳對帳單失敗'})
                    }
                }else{
                    commit(types.set_fail, {status: true, msg: res.data.errorMsg})
                    dispatch('setLoadingState', 0)
                }
            })
            .catch(err => {
                commit(types.set_file_state, 'fail')
                reject(err)
            })
        })
    },
    bizdownloadBillAccountExcel ( {commit, dispatch} ) {
        return new Promise((resolve, reject) => {
            downloadBillAccountExcel()
            .then(res => {
                console.log(res)
                if( res.status == 200 ){
                    if(res.data){
                        const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" }));
                        let a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = url;
                        const timestamp = new Date().toISOString().slice(0,16).replace(/[-:]/g,'');  
                        a.download = `對帳號總表_${timestamp}.xlsx`;
                        a.click();
                        // window.open(url);
                    }
                }else{
                    dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                reject(err)
            })
        })
    },
}

// mutations
const mutations = {
    [types.set_batch_list](state, data){
        state.batchBillList = data
    },
    [types.set_upload_list](state, data){
        state.uploadList = data
    },
    [types.set_error_list](state, data){
        state.errorList = data
    },
    [types.set_default](state){
        state.batchBillList = []
        state.errorList = []
        state.set_upload_list = []
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/leaseMgt/batchBill.js